export const addEmployees = (list) => {
  const teamList = document.querySelector('[data-home-team-list]');

  if (teamList)
    teamList.appendChild(list)
}